import PropTypes from "prop-types";
import { withLocalize } from "react-localize-redux";
import { NavLink } from "react-router-dom";

const VerticalTabs = ({ translate, headerNode, nodes }) => {
  return (
    <div className="vertical-tabs container mt-3 p-0">
      {headerNode || ""}
      <div className="col-12">
        {nodes.map((node) => {
          return (
            <NavLink
              key={node.id}
              className={({ isActive }) =>
                `tab d-flex flex-start align-items-center ${
                  isActive
                    ? `border-left-orange text-dark fw-bold`
                    : `border-left-transparent`
                }`
              }
              to={node.link}
              end
            >
              {node.icon && <div className="tab-icon ps-3">{node.icon}</div>}
              <p className="mb-0 p-3 text-uppercase">
                {node.customTitle || translate(`page_titles.${node.title}`)}
              </p>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

VerticalTabs.propTypes = {
  activeTab: PropTypes.string,
  onTabClick: PropTypes.func,
  headerNode: PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.node,
    fileInputText: PropTypes.string,
  }),
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      icon: PropTypes.node,
    })
  ),
};

export default withLocalize(VerticalTabs);
